<template>
  <div>
    <div class="top_line_header" v-if="user.user.registered_line === false">
      <a href="#" @click.prevent="scrollToRefs('top_line_footer', 0)"><img src="/assets/img/top/line_header.png" alt="LINE登録はこちらから" /></a>
    </div>
    <section class="top_user_info">
      <table>
        <tr>
          <th>ニックネーム</th>
          <td><span class="top_user_info_separator"></span></td>
          <td>{{ user.user.nickname }}</td>
        </tr>
        <tr>
          <th>会員ID</th>
          <td><span class="top_user_info_separator"></span></td>
          <td>{{ user.user.id }}</td>
        </tr>
        <tr>
          <th>所持ポイント</th>
          <td><span class="top_user_info_separator"></span></td>
          <td>{{ user.point.total.toLocaleString() }}pt</td>
        </tr>
      </table>
      <p class="text_right">
        <router-link :to="{ name: 'UserProfile' }" class="arrow link_main--text">プロフィール設定はこちら</router-link>
        <router-link :to="{ name: 'UserMailChange' }" class="arrow link_main--text">メールアドレス登録・変更はこちら</router-link>
      </p>
    </section>
    <section class="top_change_font_scale text_right">
      <label for="top_change_font_scale_btn">文字サイズ</label>
      <div class="top_change_font_scale_form_wrap">
        <input
          type="checkbox"
          id="top_change_font_scale_btn"
          v-model="fontScale"
          @change="changeFontScale"
        />
        <label for="top_change_font_scale_btn"></label>
      </div>
    </section>
    <section class="top_page_top" v-if="info.page != null && info.page.body.length > 0" v-html="info.page.body">
    </section>
    <h2><img src="/assets/img/top/menu_title.png" alt="鑑定メニュー" /></h2>
    <section class="top_menu text_center">
      <ul class="pl-0">
        <li><a href="#" @click.prevent="scrollToRefs('top_menu_worry')"><img src="/assets/img/top/menu_1.png" alt="お悩み別" /></a></li>
        <li><a href="#" @click.prevent="scrollToRefs('top_menu_genre')"><img src="/assets/img/top/menu_2.png" alt="ジャンル別" /></a></li>
        <li><a href="#" @click.prevent="scrollToRefs('top_menu_free_fortune')"><img src="/assets/img/top/menu_3.png" alt="無料占い" /></a></li>
      </ul>
      <h2 ref="top_menu_worry" class="header_underline">お悩み別</h2>
      <p>
        気になる<span class="emphasis--text">【お悩み】</span>を選択して下さい。<br>
        専門の鑑定師をご紹介致します。
      </p>
      <ul class="top_menu_worry_genre pl-0">
        <li v-for="(entry, index) in worryList" :key="index">
          <router-link :to="{ name: 'GenreActorList', params: { type: 'worry', id: entry.value } }">
            <img :src="`/assets/img/worry/${entry.imageValue}.png`" :alt="entry.label" />
          </router-link>
        </li>
      </ul>

      <h2 ref="top_menu_genre" class="header_underline">ジャンル別</h2>
      <p>
        気になる<span class="emphasis--text">【ジャンル】</span>を選択して下さい。<br>
        専門の鑑定師をご紹介致します。
      </p>
      <ul class="top_menu_worry_genre pl-0">
        <li v-for="(entry, index) in genreList" :key="index">
          <router-link :to="{ name: 'GenreActorList', params: { type: 'genre', id: entry.value } }">
            <img :src="`/assets/img/genre/${entry.imageValue}.png`" :alt="entry.label" />
          </router-link>
        </li>
      </ul>

      <h2 ref="top_menu_free_fortune" class="header_underline">無料占い</h2>
      <p>一日一回本日の運気を無料で占えます。</p>
      <p><router-link :to="{ name: 'HoroscopeTop' }"><img src="/assets/img/banner_astrology.png" alt="12星座占い"></router-link></p>
    </section>
    <section class="top_domain text_center">
      <h2 class="header_underline">ドメイン指定受信</h2>
      <p class="text_left">ドメイン指定拒否を行っている方は当番組のドメイン[{{ info.mailDomain }}]を解除して下さい。</p>
      <input type="text" v-model="info.mailDomain" />
      <p class="text_left">↑上記をコピーして下記を参考にご利用ください。</p>
      <ul class="pl-0">
        <li @click="goToCarrier('docomo')">
          <img src="/assets/img/top/carrier_docomo.png" alt="NTT docomo" />
          <span>docomoをお使いの方</span>
        </li>
        <li @click="goToCarrier('au')">
          <img src="/assets/img/top/carrier_au.png" alt="au" />
          <span>auをお使いの方</span>
        </li>
        <li @click="goToCarrier('softbank')">
          <img src="/assets/img/top/carrier_softbank.png" alt="SoftBank" />
          <span>SoftBankをお使いの方</span>
        </li>
      </ul>
    </section>
    <section ref="top_line_footer" class="top_line_footer no_padding" v-if="user.user.registered_line === false">
      <div><img src="/assets/img/top/line_footer_top.png" alt="LINEで鑑定" /></div>
      <div><img src="/assets/img/top/line_footer_bottom.png" alt="友だち追加" @click="oAuthTopLine" /></div>
    </section>
  </div>
</template>

<script>
import { TOP_FONT_SCALE } from '@/store/top/actions'
import { SET_SCROLL_POSITION } from '@/store/common/mutations'
import { GET_OAUTH_TOP } from '@/store/line/actions'
import {
  GENRE_WORRY,
  GENRE_GENRE
} from '@/helper/constant'

export default {
  name: 'TopLoggedIn',
  data () {
    return {
      user: this.$store.getters.loginUser || null,
      info: this.$store.getters.siteInfo || null,
      worryList: GENRE_WORRY,
      genreList: GENRE_GENRE,
      isChangeFontScale: ((sessionStorage.getItem('isChangeFontScale') || 'false') === 'true'),
      c: null
    }
  },
  computed: {
    loginUser () {
      return this.$store.getters.loginUser
    },
    siteInfo () {
      return this.$store.getters.siteInfo
    },
    fontScale: {
      get () {
        return this.isChangeFontScale
      },
      set (value) {
        this.isChangeFontScale = value
      }
    }
  },
  methods: {
    goToCarrier (carrier) {
      this.$router.pushIsses({ name: 'CarrierDetail', params: { carrier: carrier } })
    },
    changeFontScale () {
      sessionStorage.setItem('isChangeFontScale', this.fontScale)
      this.$store.dispatch(TOP_FONT_SCALE, this.fontScale)
        .then(() => {})
        .catch(() => {})
    },
    scrollToRefs (refName, offset = 8) {
      this.$store.commit(SET_SCROLL_POSITION, this.$refs[refName].offsetTop - offset)
    },
    getQueryStrings () {
      try {
        const search = document.location.search.substring(1)
        const params = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')

        if ('isses' in params) {
          this.c = params.isses
        }
      } catch (e) {
      }
    },
    oAuthTopLine () {
      this.$store.dispatch(GET_OAUTH_TOP, {
        c: this.c
      })
        .then((data) => {
          location.href = data.url
        })
        .catch((error) => {
          if (error.errorStatus === 400) {
            location.href = error.errorData.url
          }
        })
    }
  },
  created () {
    this.getQueryStrings()
  },
  watch: {
    loginUser (val, old) {
      this.user = val
    },
    siteInfo (val, old) {
      this.info = val
    }
  }
}
</script>
